import { Switch as HeroSwitch } from '@heroui/react';

/**
 * Toggle switch — the HeroUI v3 Switch. (The legacy Aether toggle was
 * dropped when the app went HeroUI-only.) Public API kept stable:
 * checked / onChange / disabled / label / id / className.
 */
interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** aria-label for screen readers when there's no visible label nearby. */
  label?: string;
  id?: string;
  className?: string;
}

// `relative` keeps React Aria's visually hidden <input> inside the switch.
// HeroUI's `.switch` is not positioned, so the absolute hidden input was
// placed against the dialog instead and did not scroll with the settings
// list; pressing the switch focused that input and the browser scrolled the
// whole dialog to reach it (QA #427).
export function Switch(props: SwitchProps) {
  return (
    // Wrapper swallows the click so a clickable parent row (e.g. FilterToggle)
    // doesn't double-toggle.
    <span
      className={'inline-flex' + (props.className ? ' ' + props.className : '')}
      onClick={(e) => e.stopPropagation()}
    >
      <HeroSwitch
        className="relative min-h-11 min-w-11"
        id={props.id}
        isSelected={props.checked}
        onChange={props.onChange}
        isDisabled={props.disabled}
        aria-label={props.label}
      >
        <HeroSwitch.Control>
          <HeroSwitch.Thumb />
        </HeroSwitch.Control>
      </HeroSwitch>
    </span>
  );
}
